var frameIndex = 0,
    frames = $(".lookbook-wrapper .look"),
    S = {};
$(document).ready(function() {
    S.size = {}, S.size.all = function() {
      S.size.windowW = $(window).outerWidth(), S.size.windowH = $(window).outerHeight()
    },
    S.scroll = {}, S.scroll.lock = function() {
      bodyScrollLock.disableBodyScroll($("#page-container"), {
        allowTouchMove: el => {
          for (; el && el !== document.body;) {
            if (el.getAttribute("body-scroll-lock-ignore") !== null) return !0;
            el = el.parentNode
          }
        }
      })
    }, S.scroll.unlock = function() {
      bodyScrollLock.clearAllBodyScrollLocks()
    }, S.lookbook = {}, S.lookbook.init = function() {
        $("#main .lookbook").each(function() {
          $(this).find(".link-overlay").click(function(e) {
            e.preventDefault();
            var id = $(this).attr("data-id");
            S.lookbook.detail(id)
          })
        });
    }, S.lookbook.detail = function(id) {
        var looks = "",
            tot = $(".lookbook .look").length;
        $(".lookbook .look").each(function() {
          var no = $(this).index() + 1,
              src = $(this).attr("data-src-full"),
              alt = $(this).find("img").attr("alt"),
              detail_id = $(this).attr("id") + "-detail",
              pagi = '<span class="lookbook-pagi">' + no + "/" + tot + "</span>",
              caption = "",
              landscape = $(this).hasClass("landscape-true");
          $(this).find(".block-content").length && (caption = '<div class="block-content type-f">' + $(this).find(".block-content").html() + "</div>");
          var btn = '<button class="clear-btn link-overlay zoom-btn" aria-label="Zoom"><span class="displace">Zoom</span></button>';
          if (id == $(this).attr("id")) var look = `<div class="block-image"><img
                class="picture__img"
                src="` + src + `"
                data-src="` + src + `"
                data-zoom-src="` + src + `"
                alt="` + alt + `"
              />` + btn + "</div>";
          else var look = `<div class="block-image"><img
                class="picture__img lazyload"
                data-src="` + src + `"
                data-zoom-src="` + src + `"
                alt="` + alt + `"
              />` + btn + "</div>";
          look = '<div class="block-interior">' + look + caption + "</div>", looks = looks + '<div class="look-detail landscape-' + landscape + '" id="' + detail_id + '">' + look + pagi + "</div>"
        });
        var html = '<div class="lookbook-details zoom-parent" id="lookbook-details" body-scroll-lock-ignore>' + looks + '<a href="#" class="x-close" aria-label="Close"><span class="displace">Close</span></a></div>';
        $(".lookbook").after(html), S.scroll.lock(), $(".lookbook-details .x-close").click(function(e) {
          for (e.preventDefault(), S.scroll.unlock(), $(".lookbook-details").remove(), i = 0; i < S.scroll.sectionWatchers.length; ++i) S.scroll.sectionWatchers[i].destroy();
          S.scroll.sectionWatchers = []
        }), setTimeout(function() {
          var active_detail_id = "#" + id + "-detail",
              top = $(active_detail_id).position().top;
          $(".lookbook-details").scrollTop(top).addClass("inited")
        }, 200);
        var containerElement = document.getElementById("lookbook-details"),
            containerMonitor = scrollMonitor.createContainer(containerElement);
        S.scroll.sectionWatchers = [];
        var f = 0;
        $(".look-detail").each(function() {
          var $t = $(this);
          if (S.scroll.sectionWatchers[f] = containerMonitor.create($t, S.size.windowH * -.5), S.scroll.sectionWatchers[f].isInViewport) {
            $(this.watchItem).siblings().removeClass("active"), $(this.watchItem).addClass("active");
            var id2 = $(this.watchItem).attr("id");
            console.log("id2: " + id2), id2 && (id2 = id2.replace("-detail", ""), history.pushState(null, id2, "#" + id2))
          }
          S.scroll.sectionWatchers[f].enterViewport(function() {
            var id3 = $(this.watchItem).attr("id");
            if (id3 && this.isFullyInViewport == !0) {
              $(this.watchItem).siblings().removeClass("active"), $(this.watchItem).addClass("active");
              var id3 = $(this.watchItem).attr("id");
              console.log(this.isFullyInViewport), console.log("id3: " + id3 + " / this.isFullyInViewport: " + this.isFullyInViewport), id3 = id3.replace("-detail", ""), history.pushState(null, id3, "#" + id3), $(this.watchItem).index() == 9 ? $up.addClass("show") : $(this.watchItem).index() == 8 && $up.removeClass("show")
            }
          }), f++
        }), S.zoom.init($(".lookbook-details")), $(".look-detail img.lazyload").each(function() {
          $(this).attr("src", $(this).attr("data-src"))
        })
    }, S.zoom = {}, S.zoom.init = function($s) {
      $s.find(".zoom-btn").on("click", function(e) {
        e.preventDefault(), S.zoom.show($(this))
      })
    }, S.zoom.show = function($t) {
      var img = $t.siblings("img").attr("data-zoom-src");
      console.log("img: " + img), img || (img = $t.attr("data-zoom-src"));
      var scrollLeft = 0,
          scrollTop = 0;
      S.isMobile && (scrollLeft = S.size.windowW), $t.parents(".zoom-parent").first().append('<div class="zoom-image" body-scroll-lock-ignore><img src="' + img + '" /><span class="x-close"><span class="displace">Close</span></span></div>'), $(".zoom-image").addClass("inited").click(function(e) {
        e.preventDefault(), $(".zoom-image").remove(), bodyScrollLock.clearAllBodyScrollLocks()
      }), $(document).on("keyup.zoom_escape", function(e) {
        e.key === "Escape" && ($(".zoom-image.inited").trigger("click"), $(document).unbind("keyup.zoom_escape"))
      }), $(".zoom-image img").imagesLoaded(function() {
        bodyScrollLock.disableBodyScroll($("#main"), {
          allowTouchMove: el => {
            for (; el && el !== document.body;) {
              if (el.getAttribute("body-scroll-lock-ignore") !== null) return !0;
              el = el.parentNode
            }
          }
        }), $(".zoom-image").animate({
          scrollLeft,
          scrollTop
        }, 0).addClass("image-loaded")
      })
    }, S.init = function() {
      S.isTouchDevice = isTouchDevice(), S.size.all(), setTimeout(function() {
        S.size.all(), $(window).on("resize", function() {
          S.resizeTimer && clearTimeout(S.resizeTimer), S.resizeTimer = setTimeout(S.size.all, 300)
        })
      }, 100);

      $("body").on("click", ".image-viewer a.close", function(e) {
          closeViewer(e)
      }), $("body").on("click", "a.current.close", function(e) {
          e.preventDefault(), closeViewer(e)
      });

      S.zoom.init($(".main")), S.lookbook.init(), setTimeout(function() {
        $("body").addClass("init")
      }, 500), initZoom()
    }, S.init()
});

function isTouchDevice() {
  try {
    return document.createEvent("TouchEvent"), !0
  } catch {
    return !1
  }
}

function closeViewer(e) {
  e.preventDefault(), $.scrollLock(!1), frameIndex = 0, $("body").removeClass("frame-open no-scroll"), $(".image-viewer").removeClass("visible"), setTimeout(function() {
    $(".image-viewer").remove()
  }, 500)
}

function openViewer(e) {
  e.preventDefault(), $.scrollLock(!0);
  var frameSrc = frames[frameIndex].dataset.attrFullsize;
  $("body").append('<div class="image-viewer"><a class="close" href="#">CLOSE</a><div class="lookbook-style-images"><div class="frame-container grid justify-center align-center"><div class="frame-wrapper frame"><div class="frameNav prevFrame"></div><div class="frameNav nextFrame"></div><div class="photo grid justify-center align-center"><img class="img-stilframe" src="' + frameSrc + '" /></div></div></div></div></div>'), $(".image-viewer").imagesLoaded(function() {
    $("body").addClass("frame-open no-scroll"), $(".image-viewer").addClass("visible");
  })
}

$(document).on("keydown", function(e) {
  (e.keyCode == 39 || e.keyCode == 40) && plusFrame(frameIndex), (e.keyCode == 37 || e.keyCode == 38) && minusFrame(frameIndex)
});

function plusFrame(n) {
  n + 1 < frames.length && (frameIndex = n + 1, showFrame(frameIndex))
}

function minusFrame(n) {
  n > 0 && (frameIndex = n - 1, showFrame(frameIndex))
}

function currentFrame(n) {
  showFrame(frameIndex = n)
}

function showFrame(n) {
  $(".photo .img-stilframe").attr("src", frames[n].dataset.attrFullsize)
}

$(document).on("keydown", function(e) {
    e.keyCode == 27 && $("body.frame-open").length && closeViewer(e)
});

var initZoom = function() {
  isTouchDevice() ? $("body").addClass("is-touch-device") : $("body").addClass("not-touch-device"), $(".look[data-attr-fullsize]").on("click", function(e) {
    frameIndex = $(".lookbook-wrapper .look").index(this), openViewer(e)
  })
};
